import PropTypes from "prop-types"
import { TableCell, TableHead, TableRow } from "@mui/material"
import { get } from "lodash"
import classnames from "classnames"
import SortIcon from "components/sort-icon"
import { changeGroupSort, getTitle } from "helpers/contributorsSort"
import { FOUR_WAY_SORT_ORDERS } from "helpers/sorts"
import "./style.scss"

export default function ContributorsTableGroupHead({ tooltipText, displayTypeName, groupOrder, groupSort, label }) {
  const order = get(groupOrder, "order")
  return (
    <TableHead className="components_contributors-table-group-head">
      <TableRow>
        <TableCell />
        <TableCell align="right" title={getTitle(order, tooltipText)}>
          <span className={classnames("groupSort", order)} onClick={() => changeGroupSort(groupSort, order)}>
            <SortIcon order={order} />
            {label}
          </span>
        </TableCell>
      </TableRow>
      {displayTypeName && <TableRow className="group-type-name">
        <TableCell colSpan={3}>
          {displayTypeName}
        </TableCell>
      </TableRow>}
    </TableHead>
  )
}

ContributorsTableGroupHead.propTypes = {
  tooltipText: PropTypes.string,
  displayTypeName: PropTypes.string,
  groupOrder: PropTypes.shape({
    by: PropTypes.string.isRequired,
    order: PropTypes.oneOf(FOUR_WAY_SORT_ORDERS).isRequired,
  }).isRequired,
  groupSort: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
}
